import React from 'react';
import "./style.scss";

function Heading({content}) {

  return (
    <h2 className='heading'>{content.title}</h2>
  )
}
export default Heading;
